import { iTableFilterDef } from "../../../hooks/useTableFilters";
import { IFlatCorporateEvent } from "../../../interfaces/corporateEvent";
import PhCalendarBlankSvg from "../../../assets/svg-fc/PhCalendarBlankSvg";
import PhCalendarPlusSvg from "../../../assets/svg-fc/PhCalendarPlusSvg";
import PhStackSvg from "../../../assets/svg-fc/PhStackSvg";
import PhXCircleSvg from "../../../assets/svg-fc/PhXCircleSvg";

const text = (value: string | null | undefined, empty: string) => [value?.trim() || empty];

/** The corporate event lists' filter pills; keys are the row fields saved filters name. */
const CORPORATE_EVENT_FILTERS: iTableFilterDef<IFlatCorporateEvent>[] = [
	{
		key: "startDate",
		kind: "dateRange",
		label: "Start date",
		icon: <PhCalendarBlankSvg size={16} />,
		getDate: (row) => row.startDate,
	},
	{
		key: "externalDeadline",
		kind: "dateRange",
		label: "Deadline to quote",
		icon: <PhCalendarPlusSvg size={16} />,
		getDate: (row) => row.externalDeadline,
	},
	{ key: "eventType", label: "Event type", icon: <PhStackSvg size={16} />, get: (row) => text(row.eventType, "Not set") },
	{
		key: "declinedBy",
		label: "Declined by",
		icon: <PhXCircleSvg size={16} />,
		get: (row) => text(row.declinedBy, "Not set"),
	},
];

/** The pills for the columns a list shows. */
export const getCorporateEventFilterDefs = (columnKeys: string[]) =>
	CORPORATE_EVENT_FILTERS.filter((def) => columnKeys.includes(def.key));
